'use client'

import { useMemo } from 'react'

import {
  ChoicePicker,
  type ChoicePickerProps,
} from '@/features/order/choice-picker/components/choice-picker'
import {
  useInstrumentChoiceData,
  usePositionChoiceData,
} from '@/features/order/choice-picker/hooks/use-choice-data'
import type { Account } from '@/types/generated/common/account'

/**
 * ChoicePicker fed from live data: the venue catalog and tickers of the account the question
 * was asked under for instruments, the open positions for positions. The backend sends only
 * the symbols, so everything a card shows beyond them is looked up here.
 */
export function LiveChoicePicker({
  account,
  ...props
}: Omit<ChoicePickerProps, 'instrumentData' | 'positionData'> & {
  account: Account | null | undefined
}) {
  const { request } = props
  const symbols = useMemo(() => request.options.map((option) => option.reply), [request.options])
  const instrumentData = useInstrumentChoiceData(symbols, account, request.kind === 'instrument')
  const positionData = usePositionChoiceData(
    symbols,
    account?.accountId,
    request.kind === 'position'
  )
  return <ChoicePicker {...props} instrumentData={instrumentData} positionData={positionData} />
}
